// extracted by mini-css-extract-plugin
module.exports = {"container":"companyGridNew_container__1l-aR","card":"companyGridNew_card__ZlRiN"};